import React from 'react';
import ReactDOM from 'react-dom';
import App from 'components/app';
import { Provider } from 'react-redux';
import { unregister } from 'registerServiceWorker';
import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import rootReducer from 'reducers/index';
import { createBrowserHistory } from 'history';
import '../node_modules/flag-icon-css/css/flag-icon.min.css';

export const store = createStore(rootReducer, compose(applyMiddleware(thunk)));
export const history = createBrowserHistory();

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById('root')
);

// Removing service workers.
// We will not use service workers for now
unregister();



// WEBPACK FOOTER //
// ./src/index.js